import { FC } from "react";
import { Box } from "@chakra-ui/react";

export const MobileDivider: FC = () => {
  return (
    <Box
      bg="fg-on-accent"
      display={{ base: "initial", lg: "none" }}
      h={{ base: "0.25rem" }}
      my={{ base: 8, lg: "0" }}
      w={{ base: "100%", lg: "0.25rem" }}
    />
  );
};
